var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.7 7.15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15 7.15a.6.6 0 0 1-.4-.1l-3.6-3.6a.495.495 0 0 1 .7-.7l2.9 2.9c.2.2.5.2.6 0l5.5-5.5a.495.495 0 1 1 .7.7l-6.2 6.2c.1 0-.1.1-.2.1"
  })));
};
export default SvgCheck;